import React, { useState } from 'react';
import { Button, DatePicker, Popover, Space } from '@arco-design/web-react';
import { IconFilter, IconRefresh } from '@arco-design/web-react/icon';

const DateFilter = ({ onFilter, placeholder = '请选择日期' }) => {
  const [visible, setVisible] = useState(false);
  const [dateValue, setDateValue] = useState(null);
  const [hasFilter, setHasFilter] = useState(false);

  const handleFilter = () => {
    let dateStr = '';
    if (dateValue) {
      // 处理不同类型的日期对象
      if (typeof dateValue.format === 'function') {
        dateStr = dateValue.format('YYYY-MM-DD');
      } else if (dateValue instanceof Date) {
        dateStr = dateValue.toISOString().split('T')[0];
      } else if (typeof dateValue === 'string') {
        dateStr = dateValue;
      }
    }
    onFilter(dateStr);
    setHasFilter(!!dateValue);
    setVisible(false);
  };

  const handleClear = () => {
    setDateValue(null);
    onFilter('');
    setHasFilter(false);
    setVisible(false);
  };

  const content = (
    <div style={{ width: 145, padding: '8px 0' }}>
      <DatePicker
        placeholder={placeholder}
        value={dateValue}
        onChange={setDateValue}
        style={{ marginBottom: 8, width: '100%' }}
        allowClear
      />
      <Space>
        <Button
          type="primary"
          size="small"
          onClick={handleFilter}
        >
          筛选
        </Button>
        <Button
          size="small"
          icon={<IconRefresh />}
          onClick={handleClear}
        >
          重置
        </Button>
      </Space>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      visible={visible}
      onVisibleChange={setVisible}
      position="bottom"
    >
      <Button
        size="small"
        icon={<IconFilter />}
        type={hasFilter ? 'primary' : 'secondary'}
        style={{
          color: hasFilter ? '#fff' : '#86909c'
        }}
      />
    </Popover>
  );
};

export default DateFilter;